import React, { useEffect, useState } from "react";

import * as S from './styles'
import CardPlan from "../CardPlan";

function Plans({ benefits }) {
  const [currentTab, setCurrentTab] = useState(0)
  const [currentMobileCard, setCurrentMobileCard] = useState(0)
  const currentCards = benefits[currentTab].cards

  const isCardsGreaterThanCurrent = currentCards.length > 1 && currentCards.length-1 > currentMobileCard
  const isCardsLesserThanCurrent = currentCards.length > 1 && currentCards.length-1 <= currentMobileCard

  useEffect(() => {
    setCurrentMobileCard(0)
  }, [currentTab])

  function selectTab(tabIndex) {
    if(currentTab !== tabIndex) setCurrentTab(tabIndex)
  }

  /**
   * Receives a string "next" or "previous".
   * 
   * @param navigate {string}
   */
  function navigateCards(navigate) {
    if(navigate === 'next') {
      if(isCardsGreaterThanCurrent) setCurrentMobileCard(currentMobileCard+1)
    }
    else {
      if(isCardsLesserThanCurrent) setCurrentMobileCard(currentMobileCard-1)
    } 
  }

  return (
    <S.Container>
      <S.TabMenu tabAmounts={benefits.length}>
        {benefits.map((benefit, index) => (
          <S.TabButton
            key={index}
            isActive={currentTab === index}
            onClick={() => selectTab(index)}>
              {benefit.tab}
          </S.TabButton>
        ))}
      </S.TabMenu>
      <S.CardsContainer>
        <S.DesktopCards>
          {currentCards.map((card, index) => (
              <CardPlan data={card} key={index}/>
          ))}
        </S.DesktopCards>
        <S.MobileCards>
          {currentCards[currentMobileCard] && (
            <>
            {isCardsLesserThanCurrent && (
              <S.NavigateLeft onClick={() => navigateCards('previous')}>
                <img src={'/bradescoexclusive/assets/chevron-dark-left.svg'} alt='Próximo card' />
              </S.NavigateLeft>
            )}
              <CardPlan data={currentCards[currentMobileCard]} />
              {isCardsGreaterThanCurrent && (
                <S.NavigateRight onClick={() => navigateCards('next')}>
                  <img src={'/bradescoexclusive/assets/chevron-dark-right.svg'} alt='Próximo card' />
                </S.NavigateRight>
              )}
            </>
          )}
        </S.MobileCards>
        {currentTab === 0 && (
          <S.SmallText>
            <p>
              *Valor calculado de acordo com a média de gastos das últimas 3
              faturas fechadas.
            </p>
          </S.SmallText>
        )}
      </S.CardsContainer>
    </S.Container>
  )
}

export default Plans